import React from 'react';

const WelcomeSection: React.FC = () => {
  const scrollToHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-orange-900 to-red-900">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20digital%20technology%20background%20with%20AI%20neural%20networks%2C%20data%20visualization%2C%20holographic%20interfaces%2C%20vibrant%20orange%20and%20red%20gradients%2C%20minimalist%20tech%20aesthetic%2C%20professional%20business%20environment%2C%20warm%20orange%20lighting&width=1920&height=1080&seq=cadastro-bg-orange&orientation=landscape')`
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-transparent" />
      
      {/* Header with Logo */}
      <div className="absolute top-0 left-0 right-0 z-20">
        <div className="container mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <div 
              className="flex items-center cursor-pointer group" 
              onClick={scrollToHome}
            >
              <img 
                src="https://static.readdy.ai/image/60d079db6e314477a5615b4d3efd8435/1aa70460cb4235142615a402493549d1.png" 
                alt="M4 Digital" 
                className="h-12 w-auto transition-all duration-300 group-hover:scale-105"
              />
            </div>
            
            <button
              onClick={scrollToHome}
              className="text-white/80 hover:text-white transition-all duration-300 flex items-center space-x-2 group"
            >
              <svg className="w-5 h-5 transition-transform duration-300 group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span className="font-medium">Voltar ao site</span>
            </button>
          </div>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="container relative z-10 px-4 md:px-6">
        <div className="text-center max-w-5xl mx-auto text-white">
          
          {/* Main Title */}
          <h1 className="text-3xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight">
            <span className="block">Seja bem</span>
            <span className="block gradient-text-orange">vindo</span>
          </h1>
          
          {/* Subtitle */}
          <h2 className="text-lg md:text-4xl lg:text-5xl font-semibold mb-6 text-gray-200">
            Parabéns pela decisão de levar sua empresa para um 
            <span className="gradient-text-orange"> outro nível</span>
          </h2>
          
          {/* Description */}
          <p className="text-base md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-3xl mx-auto">
            Esta é a primeira etapa para inserir sua empresa no ambiente Digital. 
            Preencha o formulário abaixo e nossa equipe entrará em contato.
          </p>
          
          {/* Decorative Elements */}
          <div className="flex justify-center items-center space-x-4 mb-6">
            <div className="w-16 h-1 bg-gradient-to-r from-transparent to-orange-500 rounded-full"></div>
            <div className="w-3 h-3 bg-orange-500 rounded-full animate-pulse"></div>
            <div className="w-16 h-1 bg-gradient-to-r from-orange-500 to-transparent rounded-full"></div>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold gradient-text-orange mb-2">1.200+</div>
              <div className="text-gray-300">Empresas Impactadas</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold gradient-text-orange mb-2">40%+</div>
              <div className="text-gray-300">Aumento Médio de Vendas</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold gradient-text-orange mb-2">24/7</div>
              <div className="text-gray-300">Automação Inteligente</div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default WelcomeSection;
